module.exports = __webpack_public_path__ + "static/blake-footer-bg-36057392bed797d3c8907f63729a131c.jpg";